var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGratefulIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5965 22.2755C51.5965 22.2755 51.3213 16.9031 46.0451 15.1802C46.0451 15.1802 41.6183 13.7563 38.5195 18.0398C38.5195 18.0398 45.7699 14.5819 51.5845 22.2755H51.5965Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4462 41.7186C49.5165 41.7186 52.8161 37.1759 52.8161 31.5722C52.8161 25.9685 49.5165 21.4258 45.4462 21.4258C41.3758 21.4258 38.0762 25.9685 38.0762 31.5722C38.0762 37.1759 41.3758 41.7186 45.4462 41.7186Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6811 37.1581C46.7162 37.1581 48.3661 34.8868 48.3661 32.0849C48.3661 29.2831 46.7162 27.0117 44.6811 27.0117C42.6459 27.0117 40.9961 29.2831 40.9961 32.0849C40.9961 34.8868 42.6459 37.1581 44.6811 37.1581Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 22.4763C17.2461 22.4763 17.3179 17.092 22.5223 15.1776C22.5223 15.1776 26.8893 13.5862 30.1436 17.7501C30.1436 17.7501 22.7616 14.5674 17.2461 22.4763V22.4763Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6462 31.5722C30.6462 37.1718 27.3441 41.7186 23.2762 41.7186C19.2084 41.7186 15.9062 37.1718 15.9062 31.5722C15.9062 25.9725 19.2084 21.4258 23.2762 21.4258C27.3441 21.4258 30.6462 25.9725 30.6462 31.5722Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0424 37.1581C26.0776 37.1581 27.7274 34.8868 27.7274 32.0849C27.7274 29.2831 26.0776 27.0117 24.0424 27.0117C22.0072 27.0117 20.3574 29.2831 20.3574 32.0849C20.3574 34.8868 22.0072 37.1581 24.0424 37.1581Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4769 56.34C29.5491 57.7107 32.021 58.5429 34.7132 58.5429C37.7317 58.5429 40.4729 57.5067 42.6674 55.8342C39.9263 54.1372 34.9661 54.129 34.9661 54.129C30.1936 54.1127 27.7217 56.1279 27.4688 56.34H27.4769Z",
    fill: "#F01F29",
    stroke: "#F01F29",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8968 47.7656C22.4434 51.3391 24.5401 54.3987 27.477 56.3404C29.5492 57.7111 32.0211 58.5433 34.7133 58.5433C37.7319 58.5433 40.473 57.5071 42.6676 55.8346C45.2211 53.8847 47.024 51.0536 47.5298 47.7819C41.9986 50.1153 32.5188 52.4079 21.8887 47.7656H21.8968Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3693 49.263C63.4727 49.263 66.7991 45.9363 66.7991 41.8327C66.7991 37.729 63.4727 34.4023 59.3693 34.4023C55.2659 34.4023 51.9395 37.729 51.9395 41.8327C51.9395 45.9363 55.2659 49.263 59.3693 49.263Z",
    fill: "#F97D85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 49.263C14.2031 49.263 17.5296 45.9363 17.5296 41.8327C17.5296 37.729 14.2031 34.4023 10.0998 34.4023C5.99639 34.4023 2.66992 37.729 2.66992 41.8327C2.66992 45.9363 5.99639 49.263 10.0998 49.263Z",
    fill: "#F97D85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGratefulIcon);
export default __webpack_public_path__ + "static/media/grateful-icon.94d22af3f323ee09518f49645912d716.svg";
export { ForwardRef as ReactComponent };